import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { HashRouter as Router } from 'react-router-dom';
import CustomCursor from './Component/CustomCursor';
import BackToTop from './Component/BackToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
      <CustomCursor />
      <BackToTop />
    </Router>
  </React.StrictMode>
);


